import { Button, Card, CardContent } from "@material-ui/core";
import { Check, Trash, Warning, X } from "phosphor-react";
import useStyles from "./ConfirmationModal.style";

export default function ConfirmationModal({
  modalTitle,
  helperText,
  confirmButtonText,
  cancelButtonText,
  handleCloseDeleteModal,
  handleAction,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.CardContent}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className={classes.trashContainer}>
              <Warning size={100} className={classes.trashIcon} />
            </div>
            <div style={{ width: "75%" }}>
              <p className={classes.headText}>{modalTitle}</p>
              <p className={classes.text}>{helperText}</p>
            </div>
          </div>
          <div className={classes.buttonDiv}>
            <Button
              className={classes.yesButton}
              type="submit"
              size="small"
              disableElevation
              onClick={(e) => {
                e.stopPropagation();
                handleAction();
              }}
            >
              <Check size={20} />
              {confirmButtonText}
            </Button>
            <Button
              className={classes.noButton}
              type="submit"
              size="small"
              disableElevation
              onClick={(e) => {
                e.stopPropagation();
                handleCloseDeleteModal();
              }}
            >
              <X size={20} />
              {cancelButtonText}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
